import twColors from 'tailwindcss/colors';

const colors = {
  gray: {
    ...twColors.gray,
    150: '#f1f1f1',
  },
  slate: {
    ...twColors.slate,
    150: '#E9EEF5',
  },
  neutral: {
    ...twColors.neutral,
    150: '#EDEDED',
  },
  navy: {
    50: '#E7E9EF',
    100: '#C2C9D6',
    200: '#A5AFC4',
    300: '#6D7EA1',
    400: '#5C6B8A',
    450: '#465675',
    500: '#384766',
    600: '#313E59',
    700: '#24314A',
    750: '#222E45',
    800: '#202B40',
    900: '#182030',
  },
  mirage: {
    50: '#DDE5F5',
    100: '#B4BFD9',
    200: '#9EAAC4',
    300: '#6C7C9E',
    400: '#3D4E70',
    450: '#293859',
    500: '#1E2B47',
    600: '#1A2640',
    700: '#101A2E',
    750: '#0F1729',
    800: '#0C1221',
    900: '#050A16',
  },
  black: {
    50: '#EBEBED',
    100: '#D9D9DE',
    200: '#C5C5CC',
    300: '#93939C',
    400: '#4A4A4F',
    450: '#333338',
    500: '#242428',
    600: '#1F1F21',
    700: '#131314',
    750: '#0C0C0D',
    800: '#080809',
    900: '#000000',
  },
  mint: {
    50: '#E1E5EA',
    100: '#C5CCD3',
    200: '#A0ABB6',
    300: '#70838F',
    400: '#506877',
    450: '#384954',
    500: '#2A3942',
    600: '#242F38',
    700: '#152129',
    750: '#111B22',
    800: '#0D161C',
    900: '#0A1014',
  },
  cinder: {
    50: '#E6E7EB',
    100: '#D0D2DB',
    200: '#B7BAC4',
    300: '#838794',
    400: '#4C4F57',
    450: '#383A41',
    500: '#2A2C32',
    600: '#232429',
    700: '#1C1D21',
    750: '#1A1B1F',
    800: '#15161A',
    900: '#0E0F11',
  },
  henddu: {
    50: 'var(--primary-50, #f0fdff)',
    100: 'var(--primary-100, #ccfbf1)',
    200: 'var(--primary-200, #99f6e4)',
    300: 'var(--primary-300, #5eedd8)',
    400: 'var(--primary-400, #2dd4bf)',
    500: 'var(--primary-500, #14b8a6)',
    600: 'var(--primary-600, #0d7377)',
    700: 'var(--primary-700, #0f766e)',
    800: 'var(--primary-800, #115e59)',
    900: 'var(--primary-900, #134e4a)',
    950: 'var(--primary-950, #052e2f)',
  },
  deepBlue: {
    50: '#e7eef4',
    100: '#cfdde9',
    200: '#9fbacc',
    300: '#6f98b0',
    400: '#3f7593',
    500: '#103A5E',
    600: '#0e3353',
    700: '#0c2c49',
    800: '#091f33',
    900: '#071623',
    950: '#030b12',
  },
  indigo: twColors.indigo,
  blue: twColors.blue,
  green: twColors.green,
  amber: twColors.amber,
  purple: twColors.purple,
  rose: twColors.rose,
  variants: {
    'secondary-lighter': '#FF75DF',
    'secondary-light': '#FF2ECF',
    secondary: '#E000AD',
    'secondary-darker': '#B8008C',
    'info-lighter': twColors.sky['400'],
    'info-light': twColors.sky['500'],
    info: twColors.sky['600'],
    'info-darker': twColors.sky['700'],
    'success-lighter': twColors.emerald['400'],
    'success-light': twColors.emerald['500'],
    success: twColors.emerald['600'],
    'success-darker': twColors.emerald['700'],
    'warning-lighter': '#FFBA42',
    'warning-light': '#FFA71A',
    warning: '#F59200',
    'warning-darker': '#DB7C00',
    'error-lighter': '#FF8A5C',
    'error-light': '#FF6933',
    error: '#FF4F1A',
    'error-darker': '#E52E00',
  },
};

// Station colors for time series charts (avoiding primary teal and blue colors)
// Extended palette with distinct, well-separated colors for better visual differentiation
const STATION_COLORS = [
  '#118AB2', // ocean blue
  '#F59E0B', // amber
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#84CC16', // lime
  '#A855F7', // purple
  '#E63946', // coral red
  '#073B4C', // dark teal
  '#FFD166', // warm yellow
  '#9B5DE5', // lavender
  '#00F5D4', // aqua
  '#F15BB5', // hot pink
  '#9B2335', // burgundy
  '#4ECDC4', // turquoise
  '#C7F464', // lime green
  '#7B2CBF', // deep purple
  '#FF9F1C', // tangerine
  '#F97316', // orange
  '#6366F1', // indigo
];

export { twColors, colors, STATION_COLORS };
